const KEY = "livora_device_session_id";

function createSessionId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${Date.now()}_${Math.random().toString(36).slice(2)}`;
}

export function getOrCreateDeviceSessionId() {
  try {
    const existing = String(localStorage.getItem(KEY) || "").trim();
    if (existing) return existing;
  } catch (_) {}

  const sessionId = createSessionId();

  try {
    localStorage.setItem(KEY, sessionId);
  } catch (_) {}

  return sessionId;
}

export function clearDeviceSessionId() {
  try {
    localStorage.removeItem(KEY);
  } catch (_) {}
}
